<div class="modal-header">
    <span>{{title}}</span>
    <div class="header-inside">
        <ng-content></ng-content>
        <mat-icon mat-dialog-close>clear</mat-icon>
    </div>
</div>